<template>
  <div class="mainContainer">
    <e-header></e-header>

    <!--内容区开始-->
    <div class="contentView">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
import header from "../components/header/index.vue";
export default {
  name: 'layout',
  components: {
    "e-header": header,
  },
  data() {
    return {
    };
  },
  watch: {
		$route(to, from) {
			document.documentElement.scrollTop = 0;
		}
	},
};
</script>

<style lang="less" scoped>
  .mainContainer{
    .contentView{
      max-width: 1600px;
      margin: auto;
      box-sizing: border-box;
    }
  }
</style>